/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id != "add-item-qv") {
            Shopify.cartPopapForm(variant_id);
          } else {
          	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              	jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("src");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
  	jQuery('.productmsg').text('"'+title+'"');  
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = jQuery('#ProductPhotoImg').attr("src");
  	var title = jQuery('#popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
	jQuery('.productmsg').text('"'+title+'"');
	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = window.money_format;
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

  
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          
          if (value.length == 1) {
            jQuery(".single-product-cart").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class="mini-cart__product"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')" class="remove-from-cart remove"><i class="dl-icon-close"></i></a><div class="mini-cart__product__image"><img src="' + item.image + '" alt="{{ item.alt }}"></div><div class="mini-cart__product__content"><a class="mini-cart__product__title" href="' + item.url + '">' + item.title + '</a><span class="mini-cart__product__quantity">' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></li>').appendTo(table);
            });
          }			
          else if (value.length) {
            jQuery(".single-product-cart").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<li class="mini-cart__product"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')" class="remove-from-cart remove"><i class="dl-icon-close"></i></a><div class="mini-cart__product__image"><img src="' + item.image + '" alt="{{ item.alt }}"></div><div class="mini-cart__product__content"><a class="mini-cart__product__title" href="' + item.url + '">' + item.title + '</a><span class="mini-cart__product__quantity">' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div></li>').appendTo(table);
            });
          }
          else {
            jQuery(".single-product-cart").css({"display": "none"});
            jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });

      
    }
  }
  //cart.total_price

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.original_total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);
var total_mini_cart=Shopify.formatMoney(cart.original_total_price, formatMoney);
var nuevaCadena = total_mini_cart.replace("$", ""); // Elimina la primera coma
var nuevaCadena2= nuevaCadena.replace("MXN", "");
var nuevaCadena3= parseFloat(nuevaCadena2);
var nuevaCadena4= nuevaCadena.replace(",", "");
var nuevaCadena5= parseFloat(nuevaCadena4);
/*console.log("registrado es:");
console.log(registrado);
if(nuevaCadena5 < 1000  && ya_compro == 0){console.log("menos de 1000")
  var botones_checkout='La cantidad minima para compra son $1,000.00 MXN <a  class="btn btn-fullwidth btn-style-1" style="color:#ffffff; cursor: not-allowed" id="mini-cart.checkout">Comprar</a>';
  changeHtmlValue(".mini-cart__checkout_button",botones_checkout);
}
else{ console.log("más de 1000");
  var botones_checkout='<a href="/checkout" class="btn btn-fullwidth btn-style-1" id="mini-cart.checkout">Comprar</a>';
  changeHtmlValue(".mini-cart__checkout_button",botones_checkout);*/

  console.log("BAZARTE: carrito actualizado");
console.log("BAZARTE: registrado =", registrado);
console.log("BAZARTE: ya_compro =", ya_compro);

var bazarteHasPurchase = localStorage.getItem("bazarte_has_purchase");

console.log("BAZARTE: localStorage bazarte_has_purchase =", bazarteHasPurchase);


if (
  nuevaCadena5 < 1000 &&
  bazarteHasPurchase !== "1"
) {

  console.log("BAZARTE: menor a $1000 y cliente sin compras");

  var contenedorCheckout =
    document.querySelector(".mini-cart__checkout_button");

  if (contenedorCheckout) {

    contenedorCheckout.innerHTML =
  '<span style="display:block; margin-bottom:8px;">La cantidad minima para compra son $1,000.00 MXN</span>' +
  '<a class="btn btn-fullwidth btn-style-1" ' +
  'style="color:#ffffff; cursor:not-allowed; opacity:0.6;" ' +
  'id="mini-cart.checkout">Comprar</a>' +
  '<button type="button" ' +
  'class="btn btn-fullwidth btn-style-1 bazarte-validar-correo" ' +
  'style="margin-top:8px;" ' +
  '>Validar correo</button>';

  }

} else {

  console.log("BAZARTE: puede comprar sin mínimo");

  var contenedorCheckout =
    document.querySelector(".mini-cart__checkout_button");

  if (contenedorCheckout) {

    contenedorCheckout.innerHTML =
      '<a href="/checkout" class="btn btn-fullwidth btn-style-1" ' +
      'id="mini-cart.checkout">Comprar</a>';

  }

  if (registrado == 0) {

    const elementoPopUp1 =
      document.getElementById("globo-formbuilder-112208");

    if (elementoPopUp1) {

      const elementoDentroPopUp1 =
        elementoPopUp1.querySelector(".floating-button");

      if (elementoDentroPopUp1) {
        elementoDentroPopUp1.style.display = "none";
      }

    }

    /* cookies */
    const valorCookie = getCookie("cookie_popup");

    if (valorCookie !== null) {

      console.log(
        "La cookie no ha caducado. Valor:",
        valorCookie
      );

    } else {

      console.log(
        "La cookie ha caducado o no existe."
      );

      function esperarPopupGlobo(intentos) {

        const elementoPopUp =
          document.getElementById(
            "globo-formbuilder-112208"
          );

        if (elementoPopUp) {

          console.log(
            "BAZARTE: popup Globo disponible"
          );

          AbrirPopUp();

          return;
        }

        if (intentos > 0) {

          console.log(
            "BAZARTE: popup Globo todavía no está disponible. Reintentando..."
          );

          setTimeout(function () {
            esperarPopupGlobo(intentos - 1);
          }, 500);

        } else {

          console.log(
            "BAZARTE: no se pudo encontrar el popup Globo"
          );

        }
      }

      // Intentar durante aproximadamente 10 segundos
      esperarPopupGlobo(20);
    }
    /* fin cookies */

  }
}



  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};